// П-2, П-3 (встреча 22.10.2026): история смен для администратора и старшего диспетчера — кто принимал и сдавал
// смену, какие задачи за смену заведены, закрыты и переданы дальше, заметки при сдаче; смены операторов РБУ.

import { useState } from "react";
import { fmtDateTime, fmtNum, localISODate } from "../../shared/format";
import { navigate } from "../../shared/router";
import { Empty, Field, Input, Loading, Select, useAsync } from "../../shared/ui";
import { api, useCtx } from "../ctx";

function daysAgo(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return localISODate(d);
}

export function ShiftHistory() {
  const { refs } = useCtx();
  const [from, setFrom] = useState(daysAgo(7));
  const [to, setTo] = useState(localISODate());
  const [kind, setKind] = useState("");
  const [unit, setUnit] = useState("");
  const h = useAsync<any>(
    () => api.get("/shifts/history", { date_from: from, date_to: to, kind: kind || undefined, unit: kind === "operator" && unit ? unit : undefined }),
    [from, to, kind, unit],
  );
  return (
    <div className="stack">
      <div className="row" style={{ alignItems: "flex-end" }}>
        <Field label="С"><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></Field>
        <Field label="По"><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} /></Field>
        <Field label="Чьи смены">
          <Select value={kind} onChange={(e) => setKind(e.target.value)} style={{ width: 200 }}
            options={[{ value: "", label: "Все" }, { value: "dispatcher", label: "Диспетчеры" }, { value: "operator", label: "Операторы РБУ" }]} />
        </Field>
        {kind === "operator" && (
          <Field label="РБУ">
            <Select value={unit} onChange={(e) => setUnit(e.target.value)} style={{ width: 200 }}
              options={[{ value: "", label: "Все РБУ" }, ...refs.units.map((u) => ({ value: u.id, label: `${u.plant_name}, ${u.name}` }))]} />
          </Field>
        )}
      </div>
      {!h.data ? <Loading error={h.error} onRetry={h.reload} /> : h.data.shifts.length === 0 ? <Empty>За выбранные дни смен нет.</Empty> : (
        <div className="stack tight">
          {h.data.shifts.map((sh: any) => <ShiftCard key={sh.id} sh={sh} />)}
        </div>
      )}
    </div>
  );
}

function ShiftCard({ sh }: { sh: any }) {
  const t = sh.tasks;
  return (
    <div className="panel pad stack tight">
      <div className="row between">
        <div>
          <b>{sh.kind === "operator" ? `Оператор · ${sh.unit || "РБУ"}` : "Диспетчер"}: {sh.user}</b>
          <div className="small muted">
            {fmtDateTime(sh.opened_at)} — {sh.closed_at ? fmtDateTime(sh.closed_at) : "смена идёт"}
            {sh.accepted_by ? ` · принял(а) ${sh.accepted_by} в ${fmtDateTime(sh.accepted_at)}` : sh.closed_at ? " · ещё не принята" : ""}
          </div>
        </div>
        {sh.open ? <span className="tag s-transit">идёт</span> : <span className="tag s-done">сдана</span>}
      </div>
      {sh.kind === "dispatcher" ? (
        <div className="small">Заявок принято: <b>{sh.orders_created}</b> · задач заведено: <b>{t.created.length}</b> · закрыто: <b>{t.closed.length}</b>{sh.closed_at && <> · передано следующей смене: <b>{t.passed.length}</b></>}</div>
      ) : (
        <div className="small">Выпущено: <b>{fmtNum(sh.output.volume_m3)} м³</b>, погрузок: <b>{sh.output.batches}</b></div>
      )}
      {sh.notes && <div className="alert info"><div className="t">Заметки при сдаче</div><div style={{ whiteSpace: "pre-wrap" }}>{sh.notes}</div></div>}
      {sh.comment && <div className="small">Комментарий: {sh.comment}</div>}
      {t && (t.created.length + t.closed.length + t.passed.length > 0) && (
        <details>
          <summary className="small link">Задачи смены</summary>
          <TaskList title="Заведены" rows={t.created} />
          <TaskList title="Закрыты" rows={t.closed} done />
          <TaskList title="Переданы следующей смене" rows={t.passed} />
        </details>
      )}
    </div>
  );
}

function TaskList({ title, rows, done }: { title: string; rows: any[]; done?: boolean }) {
  if (rows.length === 0) return null;
  return (
    <div style={{ marginTop: 6 }}>
      <div className="small muted">{title}</div>
      <ul className="small" style={{ margin: "2px 0", paddingLeft: 18 }}>
        {rows.map((r) => (
          <li key={r.id}>
            {r.title}
            {r.order_id && <> · <a className="link" href="#" onClick={(e) => { e.preventDefault(); navigate("/schedule", { order: r.order_id }); }}>заявка</a></>}
            <span className="muted">
              {done
                ? ` — ${r.status === "cancelled" ? "отменена" : "закрыта"}${r.done_by ? ` (${r.done_by}, ${fmtDateTime(r.done_at)})` : ""}${r.result ? `: ${r.result}` : ""}`
                : ` — завёл(а) ${r.created_by || "—"}, ${fmtDateTime(r.created_at)}`}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
